module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/2-4b8f7ff2d15d5148d2d24056c2ff16bc.png";